export default __webpack_public_path__ + "static/media/bg.00f3cf04.webm";